(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-soundcloud"] && !Shopify.designMode) return;
  try {
    
(function () {
  var API_SRC = 'https://w.soundcloud.com/player/api.js';

  /* 可視になったトラックだけメタ取得するための共有オブザーバ */
  var metaObserver = null;
  function getMetaObserver() {
    if (metaObserver || typeof IntersectionObserver === 'undefined') return metaObserver;
    metaObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        if (typeof el._scFetchMeta === 'function') el._scFetchMeta();
      });
    }, { rootMargin: '200px 0px' });
    return metaObserver;
  }

  function initTrack(el) {
    if (el.dataset.scInit) return;
    el.dataset.scInit = '1';

    var btn = el.querySelector('[data-sc-play]');
    var label = el.querySelector('.custom-music__play-label');
    var playerBox = el.querySelector('[data-sc-player]');
    var img = el.querySelector('[data-sc-art]');
    var titleEl = el.querySelector('[data-sc-title]');
    var artistEl = el.querySelector('[data-sc-artist]');
    if (!playerBox) return;

    var url = playerBox.getAttribute('data-sc-url');
    var iframe = null;
    var widget = null;

    /* メタ取得は一度だけ、可視になってから実行 */
    var metaDone = false;
    el._scFetchMeta = function () {
      if (metaDone) return;
      metaDone = true;
      fetchMeta(url, img, titleEl, artistEl);
    };

    var obs = getMetaObserver();
    if (obs) {
      obs.observe(el);
    } else {
      el._scFetchMeta(); /* IO 非対応環境はフォールバックで即取得 */
    }

    function bindWidget() {
      if (widget || typeof SC === 'undefined' || !iframe) return;
      widget = SC.Widget(iframe);
      el._scWidget = widget;
      widget.bind(SC.Widget.Events.PLAY, function () {
        closeOthers(el);
        el.classList.add('is-playing');
        if (label) label.textContent = 'PAUSE';
      });
      widget.bind(SC.Widget.Events.PAUSE, function () {
        el.classList.remove('is-playing');
        if (label) label.textContent = 'PLAY';
      });
      widget.bind(SC.Widget.Events.FINISH, function () {
        el.classList.remove('is-playing');
        if (label) label.textContent = 'PLAY';
      });
    }

    function buildPlayer() {
      if (iframe) return;
      iframe = document.createElement('iframe');
      iframe.setAttribute('frameborder', 'no');
      iframe.setAttribute('allow', 'autoplay');
      iframe.setAttribute('title', 'SoundCloud player');
      iframe.src = 'https://w.soundcloud.com/player/?url=' + url +
        '&auto_play=true&visual=false&hide_related=true&show_comments=false' +
        '&show_user=false&show_reposts=false&show_teaser=false&download=false' +
        '&sharing=false&buying=false&show_artwork=false&color=%23000000';
      playerBox.appendChild(iframe);

      if (typeof SC !== 'undefined') {
        bindWidget();
      } else {
        /* SC API 未読込のときはロード後に bind し直す */
        loadSCApi(bindWidget);
      }
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (!iframe) {
          buildPlayer();
          el.classList.add('is-open');
          return;
        }
        if (widget) {
          if (el.classList.contains('is-playing')) {
            widget.pause();
          } else {
            closeOthers(el);
            widget.play();
          }
        }
      });
    }
  }

  function closeOthers(current) {
    document.querySelectorAll('[data-sc-track]').forEach(function (other) {
      if (other === current) return;
      if (other._scWidget) other._scWidget.pause();
      other.classList.remove('is-open'); /* 開いていた行も畳む */
    });
  }

  function fetchMeta(url, img, titleEl, artistEl) {
    var trackUrl = decodeURIComponent(url);
    var endpoint = 'https://soundcloud.com/oembed?format=json&url=' +
      encodeURIComponent(trackUrl);
    fetch(endpoint)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        if (img && !img.hasAttribute('data-locked') && data.thumbnail_url) {
          img.src = data.thumbnail_url.replace('-large', '-t500x500');
          img.addEventListener('load', function () {
            img.setAttribute('data-loaded', '');
          }, { once: true });
        } else if (img) {
          img.setAttribute('data-loaded', '');
        }
        if (titleEl && !titleEl.hasAttribute('data-locked') && data.title) {
          var t = data.title;
          if (data.author_name) {
            var esc = data.author_name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            t = t.replace(new RegExp('\\s+by\\s+' + esc + '\\s*$', 'i'), '');
          }
          titleEl.textContent = t;
        }
        if (artistEl && !artistEl.hasAttribute('data-locked') && data.author_name) {
          artistEl.textContent = data.author_name;
        }
      })
      .catch(function () {});
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-sc-track]').forEach(initTrack);
  }

  function setupLoadMore(root) {
    (root || document).querySelectorAll('.custom-music').forEach(function (section) {
      if (section.dataset.scMoreInit) return;
      section.dataset.scMoreInit = '1';

      var perPage = 6;
      var items = section.querySelectorAll('.custom-music__item');
      var moreWrap = section.querySelector('[data-sc-more]');
      var moreBtn = section.querySelector('[data-sc-more-btn]');
      var shown = perPage;

      function render() {
        items.forEach(function (item, i) {
          if (i < shown) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
          }
        });
        if (moreWrap) {
          if (shown >= items.length) {
            moreWrap.setAttribute('hidden', '');
          } else {
            moreWrap.removeAttribute('hidden');
          }
        }
      }

      if (items.length <= perPage) {
        if (moreWrap) moreWrap.setAttribute('hidden', '');
        return;
      }

      render();

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          shown += perPage;
          render();
        });
      }
    });
  }

  /* SC API を一度だけ読み込む。読込済みなら即コールバック */
  function loadSCApi(cb) {
    if (typeof SC !== 'undefined') {
      if (cb) cb();
      return;
    }
    var existing = document.querySelector('script[src="' + API_SRC + '"]');
    if (existing) {
      if (cb) existing.addEventListener('load', cb);
      return;
    }
    var s = document.createElement('script');
    s.src = API_SRC;
    if (cb) s.onload = cb;
    document.head.appendChild(s);
  }

  function boot(root) {
    /* トラックの初期化（メタ取得は可視時に遅延）。SC API は先読みしておく */
    initAll(root);
    loadSCApi(null);
  }

  if (document.readyState !== 'loading') {
    boot(document);
    setupLoadMore(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
      setupLoadMore(document);
    });
  }

  // Theme editor: re-init when this section reloads
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    setupLoadMore(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
